module.exports = __webpack_public_path__ + "img/nav-cancel-flows.3bff825e.svg";